import React, {useState} from "react";
import {grey} from "@mui/material/colors";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import {Menu, MenuItem} from "@mui/material";
import {css} from "@emotion/css";

export function SelectFilterForCol(props: {
    list: string[];
    value: string;
    onChange(value: string): void;
    display?: (value: string) => string;
}) {
    const display = props.display || ((value: string) => value);

    const [open, setOpen] = useState<HTMLElement|null>(null);

    return (
        <>
            <button className={selectStyle} onClick={e => setOpen(e.currentTarget)}>
                <div style={{flex: 1}}>{(props.value && display(props.value)) || <span style={{color: grey["600"], fontWeight: "lighter"}}>Filter</span>}</div>
                <ArrowDropDown />
            </button>
            {open && <Menu
                open
                onClose={() => setOpen(null)}
                anchorEl={open}
            >
                <MenuItem onClick={() => {
                    props.onChange("");
                    setOpen(null);
                }}><i>None</i></MenuItem>
                {props.list.map(l => <MenuItem key={l} onClick={() => {
                    props.onChange(l);
                    setOpen(null);
                }}>{display(l)}</MenuItem>)}
            </Menu>}
        </>
    );
}

const selectStyle = css({

    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 0,
    paddingBottom: 0,
    textAlign: "left",
    width: "100%",
    cursor: "pointer",

    display: "flex",
    alignItems: "center",
    background: "none",
    border: "none",
    "&:hover": {
        opacity: 0.7,
    }
})